/**
 * @description
 * Registration funnel analytics (GA4).
 * See race/docs/plans/registration-analytics-plan.md for the event catalogue and definitions.
 */

/**
 * Rollout switch for the new funnel events.
 * The legacy AnalyticsRegistrationEvents keep running next to it until the counts have been compared.
 */
export const REGISTRATION_ANALYTICS_ENABLED = true;

export const RegistrationAnalyticsEvent = {
  viewed: 'reg_viewed',
  resumed: 'reg_resumed',
  blocked: 'reg_blocked',
  authRedirect: 'reg_auth_redirect',
  authReturned: 'reg_auth_returned',
  formStarted: 'reg_form_started',
  sectionStarted: 'reg_section_started',
  productViewed: 'reg_product_viewed',
  productAdded: 'reg_product_added',
  submitClicked: 'reg_submit_clicked',
  validationFailed: 'reg_validation_failed',
  submitRejected: 'reg_submit_rejected',
  systemError: 'reg_system_error',
  beginCheckout: 'begin_checkout',
  addPaymentInfo: 'add_payment_info',
  paymentFailed: 'reg_payment_failed',
  paymentProcessing: 'reg_payment_processing',
  paymentCancelled: 'reg_payment_cancelled',
  checkoutExpired: 'reg_checkout_expired',
  checkoutRestarted: 'reg_checkout_restarted',
  redirectReturned: 'reg_redirect_returned',
  statusUnresolved: 'reg_status_unresolved',
  completed: 'reg_completed',
  completionFailed: 'reg_completion_failed',
  purchase: 'purchase',
  abandoned: 'reg_abandoned',
} as const;

export type RegistrationStage = 'viewed' | 'auth' | 'form' | 'submit' | 'checkout' | 'payment' | 'completed';

/**
 * A session older than this (since its last activity) is not resumed, a new checkout_id is created instead
 */
export const SESSION_TTL_MS = 60 * 60 * 1000;

/**
 * An Odin redirect that did not come back within this time counts as an auth drop-off
 */
export const AUTH_DROPOFF_MS = 30 * 60 * 1000;

/**
 * How long the page has to stay hidden before reg_abandoned is sent
 */
export const HIDDEN_ABANDON_DELAY_MS = 30 * 1000;

/**
 * During checkout and payment users switch to BankID, Swish or their bank app to pay, so the page
 * may stay hidden until the checkout itself expires (registration_timeout, 15 minutes by default)
 */
export const CHECKOUT_HIDDEN_ABANDON_DELAY_MS = 15 * 60 * 1000;

/**
 * GA4 limit for string parameter values
 */
export const MAX_PARAM_LENGTH = 100;

export const STORAGE_KEY_PREFIX = 'reg_analytics:';
